import {
  createBrowserRouter,
  IndexRouteObject,
  NonIndexRouteObject,
  RouteObject,
} from "react-router-dom";

import BasicLayout from "./components/Layout/BasicLayout";
import LoginLayout from "./components/Layout/LoginLayout";
import Asset from "./pages/Asset/Asset";
import AssetAdmin from "./pages/AssetAdmin/AssetAdmin";
import AssetError from "./pages/AssetError/AssetError";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/Login/Login";
import PrivateRoute from "./providers/auth/PrivateRoute";
import PublicRoute from "./providers/auth/PublicRoute";
import type { Handle } from "./utils/reactRouterHelper";

/**
 * We create our custom route object so we can add a handle to it and be sure
 * it's typed properly.
 */
type RouteObjectWithHandle =
  | IndexRouteObjectWithHandle
  | NonIndexRouteObjectWithHandle;

interface IndexRouteObjectWithHandle
  extends Omit<IndexRouteObject, "children"> {
  handle?: Handle;
  children?: RouteObjectWithHandle[];
}

interface NonIndexRouteObjectWithHandle
  extends Omit<NonIndexRouteObject, "children"> {
  handle?: Handle;
  children?: RouteObjectWithHandle[];
}

const routes: RouteObjectWithHandle[] = [
  {
    path: "/",
    element: (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PrivateRoute>
          <BasicLayout />
        </PrivateRoute>
      </div>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
        handle: {
          crumb: (_params) => ({ title: "Dashboard" }),
        },
      },
      {
        path: "dashboard",
        element: <Dashboard />,
        handle: {
          crumb: (_params) => ({ title: "Dashboard" }),
        },
        children: [
          {
            path: "factory/:factoryId/asset/:assetId",
            element: <Asset />,
            handle: {
              crumb: (params) => ({
                title: `Factory: ${params["factoryId"] ?? "-"} Asset: ${params["assetId"] ?? "-"}`,
              }),
            },
            children: [
              {
                path: "admin",
                element: <AssetAdmin />,
                handle: {
                  crumb: (_params) => ({ title: "Admin" }),
                },
              },
              {
                path: "asset-signal/:assetSignalId/asset-error/:assetErrorId",
                element: <AssetError />,
                handle: {
                  crumb: (params) => ({
                    title: params["assetErrorId"] ?? "-",
                  }),
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PublicRoute>
          <LoginLayout />
        </PublicRoute>
      </div>
    ),
    children: [
      {
        index: true,
        element: <Login />,
      },
    ],
  },
];

export const router = createBrowserRouter(
  // This is not ideal but this is due to type limitations in the `react-router-dom` package.
  // In any case, it's better to have our customer route object typed properly.
  routes as unknown as RouteObject[],
);
